import { createSelector } from 'reselect';

const exchangeSelector = state => state.exchange;

export const getExchange = createSelector(
  exchangeSelector,
  exchange =>
    ({
      XOSL: 'OSEBX.OSE',
      XHEL: 'OMXH25.HEX',
      XSTO: 'OMXS30.SSE',
      XCSE: 'OMXC20.CSE',
    }[exchange.selected]),
);

export const getCurrency = createSelector(
  exchangeSelector,
  exchange =>
    ({
      XOSL: 'NOK',
      XHEL: 'EUR',
      XSTO: 'SEK',
      XCSE: 'DKK',
    }[exchange.selected]),
);

export const getCountry = createSelector(
  exchangeSelector,
  exchange =>
    ({
      XOSL: 'NO',
      XHEL: 'FI',
      XSTO: 'SE',
      XCSE: 'DK',
    }[exchange.selected]),
);

export const getSector = createSelector(
  exchangeSelector,
  exchange =>
    ({
      XOSL: 'ose',
      XHEL: 'hex',
      XSTO: 'sse',
      XCSE: 'cse',
    }[exchange.selected]),
);

export const getSearchGroup = createSelector(
  exchangeSelector,
  exchange =>
    ({
      XOSL: 'SEARCH_OB',
      XHEL: 'SEARCH_HEX',
      XSTO: 'SEARCH_SSE',
      XCSE: 'SEARCH_CSE',
    }[exchange.selected]),
);

export const getTradableSearchGroup = createSelector(
  exchangeSelector,
  exchange =>
    ({
      XOSL: 'TRADEABLE_OB',
      XHEL: 'TRADEABLE_HEX',
      XSTO: 'TRADEABLE_SSE',
      XCSE: 'TRADEABLE_CSE',
    }[exchange.selected]),
);
